import React from "react";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useStartupQuery } from '../services/api';
import { selectConfig, mergeConfig } from '../store/slices/app';

export const useConfig = () => {
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedConfig = useSelector(selectConfig);
  const config = useMemo(() => (selectedConfig && selectedConfig.settings ? selectedConfig.settings : false), [selectedConfig]);

  const { data: configData, isSuccess, isFetching: isFetchingConfig } = useStartupQuery(undefined, {skip: !Boolean(selectedConfig.client_id) || Boolean(config)});

  React.useEffect(() => {
    if(isSuccess && !configData.blocked) {
      dispatch(mergeConfig(configData));
    } else if(isSuccess && configData.blocked) {
      navigate('/maintenance');
    }
  }, [isSuccess])

  return {config};
}
